import { Injectable } from '@angular/core';
import { CoreDataService } from '@app/core/async-services/http/core.data';
import { ApiVersionedRoute } from '@app/core/async-services/http/versioned/api-versions';
import { API } from '@app/core/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  RealtimeRoomsPortfolioPayload,
  UpdateRoomCleanDetailsPayload,
  UpdateRoomCleanDetailsBody,
  RealtimeRoomsStatus,
} from './housekeeping.interface';

@Injectable({
  providedIn: 'root',
})
export class HousekeepingHttpService {
  constructor(private _coreDataService: CoreDataService) {}

  getRealtimeRoomsPortfolio(): Observable<RealtimeRoomsPortfolioPayload> {
    const options = this._coreDataService.getHttpOptions();
    return this._coreDataService
      .get<API.Response<RealtimeRoomsPortfolioPayload>>(
        `${ApiVersionedRoute.housekeeping}/realtime-inventory-portfolio`,
        options,
      )
      .pipe(
        map((response) => response.payload as RealtimeRoomsPortfolioPayload),
      );
  }

  updateRoomCleanDetails(
    body: UpdateRoomCleanDetailsBody,
  ): Observable<UpdateRoomCleanDetailsPayload> {
    const options = this._coreDataService.getHttpOptions();
    return this._coreDataService
      .post<API.Response<UpdateRoomCleanDetailsPayload>>(
        `${ApiVersionedRoute.housekeeping}/update-room-clean-details`,
        body,
        options,
      )
      .pipe(
        map((response) => response.payload as UpdateRoomCleanDetailsPayload),
      );
  }

  getRealtimeRoomsStatus(entId: string): Observable<RealtimeRoomsStatus> {
    const options = this._coreDataService.getHttpOptions({ entId });
    return this._coreDataService
      .get<API.Response<RealtimeRoomsStatus>>(
        `${ApiVersionedRoute.housekeeping}/realtime-inventory-status`,
        options,
      )
      .pipe(map((response) => response.payload as RealtimeRoomsStatus));
  }
}
